import { getShipmentMonitoringOceanImportColumns } from './ShipmentMonitoringOceanImportDef';
import { getShipmentMonitoringOceanExportColumns } from './ShipmentMonitoringOceanExportDef';
import { getShipmentMonitoringAirImportColumns } from './ShipmentMonitoringAirImportDef';
import { getShipmentMonitoringAirExportColumns } from './ShipmentMonitoringAirExportDef';
import { getShipmentMonitoringTruckingColumns } from './ShipmentMonitoringTruckingDef';
import { complexValueSortComparator } from 'shared/lib/quickFilterUtils';

/**
 * 셀 값이 object/array인 컬럼(위치·트레이드파트너·HBL/컨테이너 파생 컬럼 등)도 정상 정렬되도록
 * 기본 sortComparator를 적용. `type`이 지정됐거나 이미 자체 `sortComparator`/`sortable: false`를
 * 가진 컬럼(예: `status`)은 그대로 둠 (참고: `ShipmentMainTable.js`의 동일 패턴).
 */
function withComplexValueSortComparator(columns) {
    return columns.map((col) =>
        col.sortable === false || col.sortComparator || col.type
            ? col
            : { ...col, sortComparator: complexValueSortComparator },
    );
}

/**
 * @param {number} tabValue 0 OIM, 1 OEX, 2 AIM, 3 AEX, 4 FTL/LTL
 * @param {object[]} rows — 현재 탭 그리드 행 (스키마 힌트용, 대부분 컬럼은 rows 무관)
 */
export function getShipmentMonitoringColumnsForTab(tabValue, rows = []) {
    const columns = (() => {
        switch (tabValue) {
            case 0:
                return getShipmentMonitoringOceanImportColumns(rows);
            case 1:
                return getShipmentMonitoringOceanExportColumns(rows);
            case 2:
                return getShipmentMonitoringAirImportColumns(rows);
            case 3:
                return getShipmentMonitoringAirExportColumns(rows);
            case 4:
                return getShipmentMonitoringTruckingColumns(rows);
            default:
                return getShipmentMonitoringOceanImportColumns(rows);
        }
    })();
    return withComplexValueSortComparator(columns);
}

/** @deprecated Prefer `getShipmentMonitoringColumnsForTab(tabValue, rows)`. */
export const ShipmentMonitoringDef = (rows, tabValue = 0) => getShipmentMonitoringColumnsForTab(tabValue, rows);
